'use strict';

require('../groups/CompanyGroupUserService.js');
require('./CompanyPublicationWatcherService.js');
require('./plant/CompanyPublicationPlantService.js');

function CompanyPublicationsNewCtrl(
  $scope,
  $q,
  groups,
  allPortals,
  priorities,
  categories,
  pubCopy,
  watchersCopy,
  translations,
  $stateParams,
  $state,
  $filter,
  growl,
  currentUser,
  CompanyPublicationService,
  CompanyUserService,
  CompanyPublicationWatcherService,
  CompanyGroupUserService,
  publicationCompanyOrderService,
  publicationCompanyOrderSubcriptionService,
  CompanyPublicationCompanyInvestigationService,
  customersService,
  CompanyPublicationPlantService
) {
  $scope.groups         = groups;
  $scope.allPortals     = allPortals;
  $scope.categories     = categories;
  $scope.typeahead      = {};
  $scope.priorities     = priorities;
  $scope.createType     = "SINGLE";
  $scope.users          = new CompanyUserService.query({companyId: $stateParams.companyId});
  $scope.pubCopy = pubCopy;

  $scope.activeTab = $stateParams.activeTab || "";
  $scope.availableTypes = $scope.types.filter(function(t) {
    return $scope.currentCompany.enabledFeatures.publicationTypes.indexOf(t) !== -1;
  });

  $scope.publication = new CompanyPublicationService({
    name:     [""],
    status:   "DRAFT",
    type:     $stateParams.activeTab && $scope.availableTypes.indexOf($stateParams.activeTab) !== -1 ? $stateParams.activeTab : $scope.availableTypes[0],
    tags:     [],
    groups:   []
  });

  $scope.toggleSelectPortal = function(id) {
    var i = $scope.publication.groups.indexOf(id);
    if(-1 !== i) {
      $scope.publication.groups.splice(i, 1);
    } else {
      $scope.publication.groups.push(id);
    }
  };

  $scope.watchers = [];
  $scope.saving   = false;
  $scope.keys     = function(arg) {
    return Object.keys(arg);
  };

  $scope.$on('$typeahead.select', function() {
    if($scope.typeahead.publicationParent) {
      $scope.publication.parent = {
        id:   $scope.typeahead.publicationParent.id,
        name: $scope.typeahead.publicationParent.name
      };

      $scope.typeahead.publicationParent = '';
    }
  });

  $scope.setPublicationType = function(type) {
    $scope.publication.type = type;

    if ($scope.createType === 'BULK') {
      $scope.toggleSingle();
    }
  };


  // bulk
  $scope.toggleSingle = function() {
    $scope.createType = 'SINGLE';
    $scope.publication.name.splice(1);
  };

  $scope.toggleBulk = function() {
    $scope.createType = 'BULK';
    $scope.bulkAddItem();
  };

  $scope.bulkAddItem = function() {
    if ($scope.publication.name.length < 20) {
      $scope.publication.name.push('');
    }
  };

  $scope.bulkRemoveItem = function(item) {
    if (item > 0) {
      $scope.publication.name.splice(item, 1);
    }

    if ($scope.publication.name.length === 1) {
      $scope.toggleSingle();
    }
  };


  // settings
  $scope.setPriority = function(priority) {
    if (!priority) {
      $scope.publication.priority = null;
    } else {
      $scope.publication.priority = priority;
    }
  };

  $scope.setCategory = function(category) {
    if (!category) {
      $scope.publication.category = null;
    } else {
      $scope.publication.category = category;
    }
  };

  $scope.setGroup = function(group) {
    if (!group) {
      $scope.publication.groups = [];
      $scope.selectedGroup = null;
      $scope.members = [];
    }

    else {
      $scope.publication.groups.push(group.id);
      $scope.selectedGroup = group;

      CompanyGroupUserService.query({companyId: $stateParams.companyId, groupId: group.id}).$promise.then(function(members) {
        $scope.members = members;
      });
    }
  };


  // tags
  $scope.setTag = function(tag) {
    $scope.publication.tags.push(tag);

    angular.element('#filterTags').val('');
  };

  $scope.removeTag = function(tag) {
    $scope.publication.tags.splice($scope.publication.tags.indexOf(tag), 1);
  };

  $scope.addedTags = function(item) {
    return $scope.publication.tags.indexOf(item) === -1;
  };


  // watchers
  $scope.addWatcher = function(watcher) {
    $scope.watchers.push(watcher);

    angular.element('#filterWatchers').val('');
  };

  $scope.deleteWatcher = function(watcher) {
    $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
  };

  $scope.addedWatchers = function(watcher) {
    return $scope.watchers.indexOf(watcher) === -1;
  };

  // save
  $scope.saveAndContinueCreating = function() {
    if ($scope.group) {
      $scope.publication.groups.push($scope.group);
    }

    if($scope.publication.addedCustomer && $scope.publication.addedCustomer.extra.group && $scope.publication.groups.indexOf($scope.publication.addedCustomer.extra.group.id) === -1){
      $scope.publication.groups.push($scope.publication.addedCustomer.extra.group.id);
    }

    var saving = $scope.publication.name.map(function(name) {
      var p   = $q.defer();
      var pub = angular.copy($scope.publication);

      $scope.saving = true;

      pub.name = name;
      
      pub.$save({companyId: $stateParams.companyId}, function(resp, headers) {
        var newId    = headers('Location').split('/').pop();
        var watchers = $scope.watchers.map(function(w) {
          return new CompanyPublicationWatcherService({
            id: w.id
          }).$save({companyId: $stateParams.companyId, publicationId: newId});
        });

        if (pub.type === 'PLANT') {
          var createPlant = CompanyPublicationPlantService.update({
            companyId: $stateParams.companyId,
            publicationId: newId
          }, $scope.plant).$promise;
          watchers.push(createPlant);
        }

        if(pub.type === 'INVESTIGATION'){
          var newUser = {
            email: currentUser.email,
            name: currentUser.name,
            publication: resp,
            type: 'ANVARIG',
            user: currentUser
          };
          CompanyPublicationCompanyInvestigationService.addUsersInvestigation({
            companyId: $stateParams.companyId,
            publicationId: newId
          }, newUser);
        }

        $q.all(watchers).then(function() {
          pub.id = newId;

          p.resolve(pub);
        }, function(error) {
          p.reject(error);
        });
      }, function(error) {
        if (error.status === 400 && error.data.error && error.data.error.code === 1614) {
          growl.addErrorMessage(translations['publication.reached-your-limit']);  
        } else {
          growl.addErrorMessage(translations['publication.create-failure']);
        }
        p.reject(error);
      });

      return p.promise;
    });

    return $q.all(saving).then(function(publications) {
      $scope.saving                  = false;
      $scope.publication.name        = [""];
      $scope.publication.description = [""];

      growl.addSuccessMessage(translations['publication.create-success']);

      if(publications.length > 0) {
        return publications[publications.length - 1];
      }
      else {
        return null;
      }
    });
  };

  $scope.queryCustomers = function(text) {
    return customersService.query({
      companyId: $stateParams.companyId,
      q:         text,
      limit:     10
    }).$promise;
  };

  function addCustomer() {
    var customerDeferred = $q.defer();
    customerDeferred.resolve();
    customerDeferred.promise.then(function(){
      customersService.addObject({
        companyId: $stateParams.companyId,
        customerId: $scope.publication.addedCustomer.id
      }, {
        object: {
          id: $scope.publication.id,
          name: $scope.publication.name
        }
      });
    });

    var data = {
      customer: $scope.publication.addedCustomer
    };

    data.publication = {
      name: $scope.publication.name,
      id: $scope.publication.id
    };

    if($scope.publication.type === 'COMPANY_ORDER'){
      publicationCompanyOrderService.update({
        companyId: $stateParams.companyId,
        publicationId: $scope.publication.id
      }, data).$promise.then(function(order){
        $scope.publication.features = {
          currentCustomerId: $scope.publication.addedCustomer.id,
          currentCompanyOrderId: order.id
        };
        $scope.savePublication($scope.publication);
        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+$scope.publication.id;
      }).then(function(){
        growl.addSuccessMessage(translations['order.customer.add-success']);
      }, function(){
        growl.addErrorMessage(translations['order.customer.add-failure']);
      });
    }else{
      publicationCompanyOrderSubcriptionService.update({
        companyId: $stateParams.companyId,
        publicationId: $scope.publication.id
      }, data).$promise.then(function(order){
        $scope.publication.features = {
          currentCustomerId: $scope.publication.addedCustomer.id,
          currentCompanyOrderId: order.id
        };
        $scope.savePublication($scope.publication);
        $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: $scope.publication.id});
        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+$scope.publication.id;
      }).then(function(){
        growl.addSuccessMessage(translations['order.customer.add-success']);
      }, function(){
        growl.addErrorMessage(translations['order.customer.add-failure']);
      });
    }
  }

  $scope.save = function() {
    $scope.saveAndContinueCreating().then(function(p) {
      if( ! p) {
        $state.go('root.company.publications-list', {companyId: $stateParams.companyId});

        return;
      }
      if(p.type === 'COMPANY_ORDER' || p.type === 'ORDER_SUBCRIPTION'){
        if($scope.publication.addedCustomer.id){
          var addedCustomer = $scope.publication.addedCustomer;
          $scope.publication = p;
          $scope.publication.addedCustomer = addedCustomer;
          addCustomer(p);
        }else{
          if(p.type === 'COMPANY_ORDER'){
            window.location.href = '/order/'+$stateParams.companyId+'/detail/'+p.id;
          }
          if(p.type === 'ORDER_SUBCRIPTION'){
            window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+p.id;
          }
        }
      }else{
        if(p.type !== 'FORM' && p.type !== 'PUBLICATION_SPREAD_SHEET'){
          $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: p.id});
        }else{
          if(p.type === 'PUBLICATION_SPREAD_SHEET'){
            window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+p.id;
          }
          if(p.type === 'FORM'){
            if (
              p.features.formActived === "false" ||
              !!p.features.formActived === false
            ) {
              window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+p.id+'/detail';
            }else{
              window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+p.id+'/form-submit';
            }
          }
        }
      }
    });
  };

  if ($scope.pubCopy) {
    $scope.publication.name[0] = $scope.pubCopy.name || "";
    $scope.publication.description = $scope.pubCopy.description || "";
    $scope.publication.tags = $scope.pubCopy.tags || [];

    if ($scope.pubCopy.groups.length > 0) {
      angular.forEach($scope.pubCopy.groups, function(g){
        $scope.setGroup({
          id: g
        });
      });
    }

    if ($scope.pubCopy.category) {
      $scope.setCategory($scope.pubCopy.category);
    }

    var parent = {
      id: pubCopy.id,
      name: pubCopy.name
    };
    $scope.publication.parent = parent;

    if ($scope.pubCopy.priority) {
      $scope.setPriority($scope.pubCopy.priority);
    }

    if (watchersCopy.length > 0) {
      $scope.watchers = watchersCopy;
    }
  }

}

CompanyPublicationsNewCtrl.resolve = {
  pubCopy: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    if ($stateParams.pubCopyId) {
      return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.pubCopyId}).$promise;
    }
    return null;
  }],
  watchersCopy: ['$stateParams', 'CompanyPublicationWatcherService', function($stateParams, CompanyPublicationWatcherService){
    if ($stateParams.pubCopyId) {
      return CompanyPublicationWatcherService.query({companyId: $stateParams.companyId, publicationId: $stateParams.pubCopyId}).$promise;
    }
    return [];
  }],
  categories: ['$stateParams', 'CompanyCategoryService', 'company', function($stateParams, CompanyCategoryService) {
    return CompanyCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
  }],
  groups: ['$stateParams', '$window', 'CompanyGroupService', 'company', function($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, all: true}).$promise;
  }],
  allPortals: ['$stateParams', '$window', 'CompanyGroupService', 'company', function($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, all: true, type: 'VISIBLE'}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate(['new', 'publication.create-success', 'publication.create-failure', 'publication.reached-your-limit', 'order.customer.add-success', 'order.customer.add-failure']);
  }]
};
module.exports = CompanyPublicationsNewCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsNewCtrl', [
    '$scope',
    '$q',
    'groups',
    'allPortals',
    'priorities',
    'categories',
    'pubCopy',
    'watchersCopy',
    'translations',
    '$stateParams',
    '$state',
    '$filter',
    'growl',
    'currentUser',
    'CompanyPublicationService',
    'CompanyUserService',
    'CompanyPublicationWatcherService',
    'CompanyGroupUserService',
    'CompanyPublicationCompanyOrderService',
    'CompanyPublicationCompanyOrderSubcriptionService',
    'CompanyPublicationCompanyInvestigationService',
    'CompanyCustomersService',
    'CompanyPublicationPlantService',
    CompanyPublicationsNewCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsNewCtrl.js
// module id = 389
// module chunks = 0